module.exports = __webpack_public_path__ + "img/MarcaAgua.80c9553e.png";